const styles = {
  label: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  text: {
    height: '200px'
  },
  deleteButton: {
    marginRight: 'auto !important'
  }
}

export default styles
